import { apiFetch } from './api';

export const getMyProfile = (token) =>
  apiFetch('/users/me', {}, token);

export const updateMyProfile = (data, token) =>
  apiFetch('/users/me', { method: 'PUT', body: JSON.stringify(data) }, token);

export const getPublicProfile = (id, token) =>
  apiFetch(`/users/${id}`, {}, token);
